
        import '/home/builduser/work/5d4c7c61b0622e62/santa-editor/packages/sections/components/SectionBox/EmptyState/SectionsEmptyState.scss.css.virtualfile';
        module.exports = {"emptyStateContainer":"_emptyStateContainer_1aa30_7","linksContainer":"_linksContainer_1aa30_16","light":"_light_1aa30_19"};